import styled, { css } from 'styled-components'
import { desktopBreakpoint, mobileBreakpoint, SolidButton, tabletBreakpoint } from 'react-components'
import { EventWidgetInputContainer } from './date-picker/styles'
import { WidgetInputContainer } from '../../../search-result-listing/header-section/searchbar/widget-styles'

export const SearchbarContainer = styled.div`
    flex-grow: 1;
    margin: 0;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        height: 100%;
    }
`

interface ShowSearchButtonProps {
    searchButtonVisible: boolean
}

export const SearchbarContent = styled.form<ShowSearchButtonProps>(
    ({ searchButtonVisible, theme }) => css`
        height: 100%;
        max-width: 100%; /* 6.5rem = 104px comes from width at the sides. */
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: grid;
            grid-template-columns: 3fr 3fr;
            ${WidgetInputContainer} {
                min-height: 3.15rem;
            }

            ${!searchButtonVisible &&
            css`
                ${EventWidgetInputContainer} {
                    ${WidgetInputContainer} {
                        border-width: ${theme.typography.border.width.xxxThin};
                        border-left-width: 0;
                        border-radius: 0 0.375rem 0.375rem 0 !important;
                    }
                }
            `};

            ${searchButtonVisible &&
            css`
                grid-template-columns: 3fr 3fr 2fr;
                border-right: none;
                & > :first-child {
                    border-radius: 0.375rem 0 0 0.375rem;
                }

                & > :last-child {
                    border-radius: 0 0.375rem 0.375rem 0;
                }
            `};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin: 0 auto;
        }
    `,
)

export const AllInputsDisplayBar = styled.div.attrs({ role: 'button' })(
    ({ theme }) => css`
        border: ${theme.typography.border.width.xxxThin} solid ${theme.colors.tfwBlackOpacity10};
        border-radius: ${theme.typography.border.radius.small};
        padding: 0.6875rem ${theme.spacing.small};
        text-align: center;
        overflow: hidden;
        font-size: ${theme.typography.font.size.xSmall};
        line-height: ${theme.typography.font.size.medium};
        letter-spacing: 0.0125rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    `,
)

export const SubmitButton = styled(SolidButton as any).attrs(({ theme }: any) => ({
    forwardedAs: 'button',
    type: 'button',
    width: theme.layout.fill,
    padding: `${theme.spacing.xSmall} ${theme.spacing.small}`,
}))(
    ({ theme }) => css`
        font: ${theme.typography.font.lato.weight.bold} ${theme.typography.font.size.small} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
        border-radius: 0;
    `,
)

export const MobileSubmitButton = styled(SubmitButton)`
    border-radius: 6px;
    padding: 0.75rem 1.5rem;
    margin: 1rem;
`

export const ButtonText = styled.span.attrs({
    as: 'h3',
})`
    font: ${({ theme }) =>
        `${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.small} / ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana}`};
    text-align: center;
    margin: 0;
    padding: 0;
`
